<template>
  <transition name="fadeInUp">
    <v-dialog
      width="fit-content"
      elevation="0"
      v-model="modalIsOpen"
      @click:outside="toggleModal"
    >
      <div class="image_modal">
        <v-card
          class="d-flex justify-center"
          color="transparent"
          elevation="0"
        >
          <div class="image_wrapper">
            <video controls>
              <source :src="modalVideo" type="video/mp4">
              <source :src="modalVideo" type="video/webm">
              <source :src="modalVideo" type="video/ogg">
              Your browser does not support the video tag.
            </video>
          </div>
        </v-card>
      </div>
    </v-dialog>
  </transition>
</template>

<script>
export default {
  name: "VideoModal",

  emits: ["toggleModal"],

  props: {
    modalIsOpen: {
      type: Boolean,
      required: true,
    },
    modalVideo: {
      type: String,
      required: true,
    },
  },

  methods: {
    // Start:: Control Modal Apperance
    toggleModal() {
      this.$emit('toggleModal');
    },
    // End:: Control Modal Apperance
  },
};
</script>

<style lang="scss">
.image_modal {
  .v-card {
    padding: 0 !important;
    .image_wrapper {
      background-color: var(--white_clr);
      width: fit-content;
      border-radius: 15px;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}

  @media screen and (max-width: 850px) {
    .image_wrapper {
      height: auto;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
</style>
